<template>
    <BaseNotification role="status" hide-dismiss class="border border-border bg-surface-raised text-ink-muted">
        <template #content>
            <div class="flex grow flex-wrap items-center justify-between gap-3">
                <p class="details">{{ text }}</p>
                <BaseButton theme="primary" size="sm" :disabled="disabled" @click="emit('share')">Share back</BaseButton>
            </div>
        </template>
    </BaseNotification>
</template>

<script setup lang="ts">
import BaseButton from "~vue/components/BaseButton.vue";
import BaseNotification from "~vue/components/BaseNotification.vue";

defineProps<{ text: string; disabled: boolean }>();
const emit = defineEmits<{ share: [] }>();
</script>
